const memoizedThunks = new Map();
export function memoizeThunk(key, callback) {
    return () => {
        let result = memoizedThunks.get(key);
        if (!result) {
            result = callback();
            memoizedThunks.set(key, result);
        }
        return result;
    };
}
